<template>
  <div class="poi-button-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'poi-button-group'
  };
</script>
